// @core/api/endpoints/task/list_tasks_by_parent.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ListTasksResponse,
} from '../../../types/task';
import type { PaginatedRequest } from '../../../types/pagination';

const BASE_PATH = '/task';

/**
 * List tasks by parent
 * Returns all tasks linked to a specific parent entity such as a project, document, or another task. Enables contextual task views.
 */
export async function ListTasksByParent(
  entity_type: string,
  entity_id: string,
  params?: PaginatedRequest,
  options?: RequestOptions
): Promise<ListTasksResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/entities/:entity_type/:entity_id/tasks`;
  requestPath = requestPath.replace(':entity_type', encodeURIComponent(entity_type));
  requestPath = requestPath.replace(':entity_id', encodeURIComponent(entity_id));
  const requestOptions = options;
  return client.get<ListTasksResponse>(requestPath, { ...requestOptions, params });
}
